import { render } from "./AppFooter.vue?vue&type=template&id=7116c497"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=7116c497&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__